import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { SiteAnalytics } from './SiteAnalytics';
/**
 * SiteAnalytics implementation that uses the legacy "ga.js" implementation and
 * ga() function.
 */

var GaSiteAnalytics =
/*#__PURE__*/
function (_SiteAnalytics) {
  _inherits(GaSiteAnalytics, _SiteAnalytics);

  function GaSiteAnalytics() {
    _classCallCheck(this, GaSiteAnalytics);

    return _possibleConstructorReturn(this, _getPrototypeOf(GaSiteAnalytics).apply(this, arguments));
  }

  _createClass(GaSiteAnalytics, [{
    key: "initialPageview",
    value: function initialPageview() {
      if (typeof ga === 'undefined') {
        return;
      } // This is split out separately because the e-commerce code needs to set
      // impression data before the pageview is sent.


      ga('send', 'pageview');
    }
  }, {
    key: "changePath",
    value: function changePath(path, timeInMs) {
      if (typeof ga === 'undefined') {
        return;
      }

      ga('set', 'page', path);
      ga('send', 'pageview');

      if (typeof timeInMs !== 'undefined') {
        ga('send', 'timing', 'Router', 'routeChange', timeInMs, path);
      }
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(action) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof ga === 'undefined') {
        return;
      }

      ga('send', {
        hitType: 'event',
        eventCategory: options.category,
        eventAction: action,
        eventLabel: options.label,
        eventValue: options.value
      });
    }
  }, {
    key: "addImpression",
    value: function addImpression(id, category, list, position) {
      if (typeof ga === 'undefined') {
        return;
      }

      ga('ec:addImpression', {
        id: id,
        category: category,
        list: list,
        position: position
      });
    }
  }, {
    key: "addProduct",
    value: function addProduct(id, name, category, quantity, price) {
      if (typeof ga === 'undefined') {
        return;
      }

      ga('ec:addProduct', {
        id: id,
        name: name,
        category: category,
        quantity: quantity,
        price: price
      });
    }
  }, {
    key: "setProductAction",
    value: function setProductAction(action, options) {
      if (typeof ga === 'undefined') {
        return;
      }

      ga('ec:setAction', action, options || {});
    }
  }]);

  return GaSiteAnalytics;
}(SiteAnalytics);

export { GaSiteAnalytics as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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